import axios from "../../js/project-axios.js"

const tree = () => {
    return axios.get("/asset/category/tree");
};

const add = category => {
    return axios.post("/asset/category/add", category);
};

const update = category => {
    return axios.post("/asset/category/update", category);
};

const remove = category => {
    return axios.post("/asset/category/remove", category);
};

export default {
    tree,
    add,
    update,
    remove
};